export default "__VITE_ASSET__DicssKwZ__"